import { render, staticRenderFns } from "./SendingCategoryChart.vue?vue&type=template&id=212a7bef"
import script from "./SendingCategoryChart.vue?vue&type=script&lang=js"
export * from "./SendingCategoryChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports